// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterInput_wYQJT {
  width: 100%;
}

.tagContainer_F7ybi {
  border: 1px solid grey;
  border-radius: 4px;
  cursor: text;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  overflow-x: hidden;
  overflow-y: auto;
}

.tag_Z6xQB {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  cursor: default;
}

.tag_Z6xQB span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 150px;
  max-width: var(--size-multiSelectorTagMaxWidth, 150px);
}

.tagEditorContainer_erlpQ {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/MultiSelector.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAsD;EAAtD,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;AACjB","sourcesContent":[".filterInput {\n  width: 100%;\n}\n\n.tagContainer {\n  border: 1px solid grey;\n  border-radius: 4px;\n  cursor: text;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.tag {\n  display: inline-flex;\n  align-items: center;\n  cursor: default;\n}\n\n.tag span {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: var(--size-multiSelectorTagMaxWidth, 150px);\n}\n\n.tagEditorContainer {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterInput": `filterInput_wYQJT`,
	"tagContainer": `tagContainer_F7ybi`,
	"tag": `tag_Z6xQB`,
	"tagEditorContainer": `tagEditorContainer_erlpQ`
};
export default ___CSS_LOADER_EXPORT___;
